// accountChanged reports whether the account this page was signed in as
// (before, null until someone signs in) has gone: she signed out, or someone
// else signed in over her expired session. Module state (the card account,
// the Stripe Connect session, record versions) is per account and outlives a
// React sign-out, so the page then restarts rather than clear each by hand.
export function accountChanged(before: string | null, status: string, now: string | null): boolean {
  if (before === null) return false
  return status === 'signedOut' || (now !== null && now !== before)
}

// restartApp reloads the app from its start page, dropping all module state.
export function restartApp(): void {
  window.location.replace('/')
}
